<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基础信息" name="first">
            <el-form :model="goodsForm" :rules="rules" ref="goodsForm" label-width="190px" size="small" class="demo-ruleForm">
              <el-form-item label="套餐名称：" prop="setMealName">
                <el-input style="width: 424px;" v-model="goodsForm.setMealName" placeholder="请输入套餐名称"></el-input>
              </el-form-item>
              <el-form-item label="商品：" prop="businessIdList">
                <el-button @click="goodsOpenBtn">添加商品</el-button>
                <el-table
                  v-if="multipleSelectionSure.length > 0"
                  style="margin-top: 16px;width: 476px;"
                  border
                  :data="multipleSelectionSure">
                  <el-table-column
                    align="center"
                    prop="goodsName"
                    label="商品名称">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="goodsSpecName"
                    label="规格">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="goodsSpecPrice"
                    label="商品价格">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="stockNum"
                    width="120"
                    label="数量">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.stockNum" style="width: 96px;" controls-position="right" :min="1" :max="10"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <span @click="goodsDelBtn(scope.$index)">删除</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="套餐价格：" prop="setMealPrice">
                <el-input style="width: 424px;" placeholder="请输入套餐金额" v-model="goodsForm.setMealPrice"></el-input>
              </el-form-item>
              <el-form-item label="图片：" prop="setMealThumb">
                <el-upload
                  :action="baseUrl+'/system/common/upload/uploadFile'"
                  list-type="picture-card"
                  :headers="{'Authorization': token}"
                  :multiple="false"
                  :limit="1"
                  :file-list="fileList"
                  :on-remove="delImgBtn.bind(null,{'type':1})"
                  :on-success="uploadImgBtn">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多一张，若需要更换图片，请先删除原图片</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="商品相册：" prop="goodsSetMealPictureList">
                <el-upload
                  :action="baseUrl+'/system/common/upload/uploadFile'"
                  list-type="picture-card"
                  :headers="{'Authorization': token}"
                  :limit="5"
                  :file-list="goodsSetMealPictureListTwo"
                  :on-remove="delImgBtn.bind(null,{'type':2})"
                  :on-success="uploadTwoBtn">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多9张，若需要更换图片，请先删除原图片</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="参与分佣：" prop="enableShar">
                <el-radio-group v-model="goodsForm.enableShar">
                  <el-radio :label="1">参与</el-radio>
                  <el-radio :label="0">不参与</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="参与折扣：" prop="enableDiscount">
                <el-radio-group v-model="goodsForm.enableDiscount">
                  <el-radio :label="1">参与</el-radio>
                  <el-radio :label="0">不参与</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="余额支付：" prop="isUseMoney">
                <el-radio-group v-model="goodsForm.isUseMoney">
                  <el-radio :label="1">允许</el-radio>
                  <el-radio :label="0">不允许</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="配送方式：" prop="goodsName">
                <el-checkbox v-model="expressDelivery">快递配送</el-checkbox>
                <el-checkbox v-model="pickupDelivery">自提</el-checkbox>
                <el-checkbox v-model="enableDelivery">同城配送</el-checkbox>
              </el-form-item>
              <el-form-item label="设置邮费 ：" prop="moveTemplateId">
                <el-select style="width: 424px;" v-model="goodsForm.moveTemplateId" placeholder="请选择运费模版">
                  <el-option
                    v-for="item in moveData"
                    :key="item.id"
                    :label="item.templateName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排序：" prop="sort">
                <el-input style="width: 424px;" v-model="goodsForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
              </el-form-item>
              <el-form-item label="是否开启：" prop="status">
                <el-switch
                  v-model="goodsForm.status"
                  active-color="#1890FF"
                  inactive-color="#CCCCCC">
                </el-switch>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="medium" @click="nextBtn('second')">下一步</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="商品详情" name="second">
            <el-form :model="goodsForm" :rules="rules" ref="goodsForm" label-width="40px" size="small" class="demo-ruleForm">
              <el-form-item>
                <editor :height="690" v-model="goodsForm.setMealDetail"></editor>
              </el-form-item>
              <el-form-item>
                <el-button size="medium" @click="preBtn('first')">上一步</el-button>
                <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <!-- 选择商品弹窗 -->
    <el-dialog
      title="选择商品"
      :visible.sync="goodsShow"
      width="960px">
      <el-form :model="searchForm" inline ref="searchForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="商品名称：" prop="name">
          <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商品名称"></el-input>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        border
        :data="infoList"
        :row-key="getRowKeys"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsSpecId"
          label="ID">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsSpecThumb"
          label="商品图">
          <template slot-scope="scope">
            <el-image
              style="width: 40px;"
              :src="scope.row.goodsSpecThumb"
              :preview-src-list="[scope.row.goodsSpecThumb]"
              fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsName"
          label="商品名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsSpecName"
          label="商品规格">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsSpecPrice"
          label="商品价格">
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
      </div>
      <div class="flex-end-row" style="margin-top:24px;">
        <el-button type="primary" @click="goodsSureBtn">确认选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryAllGoodsMoveTemplateList } from '@/api/goods'
import { saveGoodsSetMealCombo, updateGoodsSetMealCombo, fetchGoodsSetMealComboDetailById, queryGoodsSpecSetMealComboPageList } from '@/api/setMenu'
import Editor from '@/components/Editor.vue'
export default {
  name: 'GroupGoodsAdd',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      dataId: this.$route.query.dataId,
      activeName: 'first',
      activeNum:0,
      goodsList:[],
      fileList: [],
      /* 商品相册 */
      goodsSetMealPictureListTwo: [],
      goodsSetMealPictureList:[],
      moveData:[],
      pickupDelivery:false,
      expressDelivery:false,
      enableDelivery:false,
      goodsForm: {
        setMealName:'',
        setMealPrice:'',
        setMealThumb: '',
        setMealDetail: '',
        pickupDelivery:'',
        expressDelivery:'',
        enableDelivery:"",
        enableShar:"",
        enableDiscount:"",
        moveTemplateId:"",
        isUseMoney:'',
        goodsSetMealPictureList:[],
        goodsSpecSetMealComboList:[],
        sort: '',
        status: false
      },
      rules: {
        setMealName: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' }
        ],
        goodsSpecSetMealComboList: [
          { required: true, message: '请选择商品', trigger: 'blur' }
        ],
        setMealPrice: [
          { required: true, message: '请输入套餐金额', trigger: 'blur' }
        ],
        setMealThumb: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        goodsSetMealPictureList: [
          { required: true, message: '请上传相册', trigger: 'blur' }
        ],
        moveTemplateId: [
          { required: true, message: '请选择模版', trigger: 'blur' }
        ]
      },
      // 选择商品弹窗
      searchForm: {
        name:''
      },
      goodsShow:false,
      multipleSelection: [],
      multipleSelectionSure: [],
      pageTotal: 0,
      currentPage: 1,
      limitLength: this.$limitLength,
      infoList:[]
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    if(this.dataId != ''){
      // 编辑信息
      this.detailInfoFun();
    }
  },
  created() {
    this.moveDataFun();
  },
  methods: {
    getRowKeys(row) {
      return row.goodsSpecId
      // 需要return的是一个唯一的标识值
    },
    /* 商品详情数据 */
    detailInfoFun(){
      var that = this;
      fetchGoodsSetMealComboDetailById({id:that.dataId}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          data.status =  data.status == 1 ? true : false;
          // 配送
          if(data.expressDelivery == 1){
            that.expressDelivery = true;
          }else{
            that.expressDelivery = false;
          }
          // 自提
          if(data.pickupDelivery == 1){
            that.pickupDelivery = true;
          }else{
            that.pickupDelivery = false;
          }
          // 同城配送
          if(data.enableDelivery == 1){
            that.enableDelivery = true;
          }else{
            that.enableDelivery = false;
          }
          // 商品主图
          that.fileList.push({url: data.setMealThumb});
          // 商品相册
          data.goodsSetMealPictureList.forEach(function(item){
            that.goodsSetMealPictureListTwo.push({url: item});
            that.goodsSetMealPictureList.push(item);
          });
          that.multipleSelectionSure = data.goodsSpecSetMealComboPageVoList;
          that.goodsForm = data;
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    },
    /* 切换选项卡操作 */
    handleClick (tab) {
      // if(tab.name == 'second'){
      //   this.moveDataFun();
      // }
    },
    /* 获取运费模版数据和省市区数据 */
    moveDataFun(){
      var that = this;
      queryAllGoodsMoveTemplateList().then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.moveData = data;
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      });
    },
    // 商品主图上传
    uploadImgBtn (file) {
      this.goodsForm.setMealThumb = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(obj,file,fileList){
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 商品主图
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.goodsForm.setMealThumb = thumb;
          break;
        case 2:
          // 商品相册
          var goodsSetMealPictureList = [];
          fileList.forEach(function(item){
            goodsSetMealPictureList.push(item.url);
          });
          that.goodsSetMealPictureList = goodsSetMealPictureList;
          break;
      }
    },
    /* 商品相册上传 */
    uploadTwoBtn (file) {
      this.goodsSetMealPictureList.push(file.data.fileUrl)
    },
    // 选择商品弹窗-打开弹窗
    goodsOpenBtn(){
      this.getInfoList();
      this.goodsShow = true;
    },
    // 选择商品弹窗-删除已选择的商品
    goodsDelBtn(index){
      this.multipleSelectionSure.splice(index,1);
    },
    /* 选择商品弹窗-搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 选择商品弹窗-选择商品操作
    handleSelectionChange(val) {
      // console.log(val,'val')
      this.multipleSelection = val;
    },
    // 选择商品弹窗-确认选择
    goodsSureBtn(){
      var multipleSelection = this.multipleSelection;
      if(multipleSelection.length == 0){
        this.$message.error('请选择商品');
        return false;
      }
      this.multipleSelectionSure = multipleSelection;
      this.goodsShow = false;
    },
    // 选择商品弹窗-获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryGoodsSpecSetMealComboPageList({ goodsName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
            item.stockNum = 1;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 选择商品弹窗-当前页码操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 下一步操作 */
    nextBtn(name){
      this.activeName = name;
    },
    /* 上一步操作 */
    preBtn(name){
      this.activeName = name;
    },
    // 保存操作
    saveBtn(){
      var that = this;
      var dataId = that.dataId;
      var goodsForm = that.goodsForm;
      var multipleSelectionSure = that.multipleSelectionSure;
      let status = goodsForm.status ? 1 : 0
      let sort = goodsForm.sort === '' ? 1 : goodsForm.sort
      let passData = {
        setMealName: goodsForm.setMealName,
        setMealPrice:goodsForm.setMealPrice,
        setMealThumb:goodsForm.setMealThumb,
        setMealDetail:goodsForm.setMealDetail,
        pickupDelivery:that.pickupDelivery == true ? 1 : 0,
        expressDelivery:that.expressDelivery == true ? 1 : 0,
        enableDelivery:that.enableDelivery == true ? 1 : 0,
        moveTemplateId:goodsForm.moveTemplateId,
        enableDiscount:goodsForm.enableDiscount,
        isUseMoney:goodsForm.isUseMoney,
        enableShar:goodsForm.enableShar,
        status:status,
        sort:sort,
        goodsSetMealPictureList:that.goodsSetMealPictureList,
        goodsSpecSetMealComboList:multipleSelectionSure
      }
      // console.log(passData,'passData');
      if(dataId != ''){
        passData.id = dataId;
        updateGoodsSetMealCombo(passData).then((res) => {
          that.backDataFun(res);
        })
      }else{
        saveGoodsSetMealCombo(passData).then((res) => {
          that.backDataFun(res);
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/setMenu/Add.vue